import styled from "styled-components";
import { Colors } from "../../styles/colors";

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.white};
  padding: 2rem 1rem;
  margin-bottom: 2rem;
`;

export const FormHeadline = styled.h2`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.5rem;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.white};
`;

export const FormFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  margin-bottom: 2rem;
  
  ${FormHeadline} {
    margin-bottom: -.5rem;
    color: ${Colors.grayDark};
    font-weight: 300;
  }
`;

export const FormButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
